import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { renderFullDate } from '../../../../../../utils/time'
import { UpdateEconomicMatch } from '../../../../../../actions/orders'
import { translation } from '../../../../../../utils/helpers'

// Elements
import Check from '../../../../../../shared/elements/check'
import Inline from '../../../../../../shared/elements/inline'

// Styles
import '../../index.scss'
import '../index.scss'

class MatchPrice extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      item: {
        Handled: false,
        HandledUserName: 'Apromas',
        HandledDate: null
      },
      wpEconomicMatchType: undefined,
      isLoading: false
    }
    this.getTextFromType = this.getTextFromType.bind(this)
  }
  componentWillReceiveProps (nextProps) {
    if (nextProps.item !== this.props.item) {
      this.setState({
        item: nextProps.item,
        wpEconomicMatchType: nextProps.wpEconomicMatchType
      })
    }
  }
  componentDidMount () {
    this.setState({
      item: this.props.item,
      wpEconomicMatchType: this.props.wpEconomicMatchType
    })
  }
  getTextFromType (type) {
    return translation(type)
  }
  render () {
    let { item } = this.state
    let handled = item.Handled === true
    let baseClass = 'matchprice_outer'
    baseClass += handled ? ' handled' : ' unhandled'
    // if (item.WpEconomicMatchType === null) return null
    const handlePriceMatch = () => {
      let data = {
        OrderId: item.OrderId,
        Checked: handled ? 0 : 1
      }
      this.setState({
        isLoading: true
      }, () => {
        this.props.UpdateEconomicMatch(data).then((res) => {
          this.setState({
            item: {
              ...this.state.item,
              Handled: res.data.Checked === true
            },
            wpEconomicMatchType: res.data.Checked === true ? 1 : 0,
            isLoading: false
          }, () => {
            // console.log(this.state.item)
            // window.toastr.success(translation('13041'), translation('13424'))
          })
        }, (res) => {
          // Toastr
          window.toastr.error(translation('216'))
          this.setState({
            isLoading: false
          })
        })
      })
    }
    let checkboxId = 'economicMatch_'
    let handledName = translation('14979').replace('%1', item.HandledUserName)
    let canNotHandle = this.state.wpEconomicMatchType === undefined || this.state.wpEconomicMatchType === null || this.state.isLoading
    if (canNotHandle) {
      baseClass = 'matchprice_outer handled'
    }
    return (
      <div className={baseClass}>
        <Inline block fillChildNum={[0]} alignChildren={'center'}>
          <div>
            {translation('14976')}
            {' - '}
            {!handled && translation('14809')}
            {handled && handledName}
            {handled && ' - '}
            {handled && renderFullDate(item.HandledDate, false)}
          </div>
          <Check labelText={translation('14977')} className='rightmatch' id={checkboxId} value={handled} checked={handled} onClick={handlePriceMatch.bind(this)} disabled={canNotHandle} />
        </Inline>
      </div>
    )
  }

}
MatchPrice.propTypes = {
  item: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  UpdateEconomicMatch
})(MatchPrice)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderList/NewItem/InvoiceLog/MatchPrice/index.js